import { connect } from 'react-redux'
import * as actions from '../LoggedIn/actions'
import { shouldRedirectUserToLogin } from '../../layouts/LoggedIn/actions'
import Layout from './Layout'

const mapStateToProps = (state, ownProps) => {
  console.log(state, ownProps)
  return {
    redirectToLogin: state.loginLayout.redirectToLogin,
    tokenVerified: state.loginLayout.tokenVerified,
    isLoggedIn: state.login.isLoggedIn,
    open: state.loginLayout.open,
    view: state.loginLayout.view,
    openSidebar: state.loginLayout.openFvDomainSidebar,
    ...ownProps
  }
}

const mapDispatchToProps = dispatch => ({
  returnUserIfUserExists: token =>
    dispatch(actions.returnUserIfUserExists(token)),
  checkValidity: token => dispatch(actions.checkValidity(token)),
  checkTokenOnPathChange: token =>
    dispatch(actions.checkTokenOnPathChange(token)),
  shouldRedirectUserToLogin: bool => dispatch(shouldRedirectUserToLogin(bool)),
  toggleSideBar: (value) => dispatch(actions.toggleFvDomainSideBar(value))
})

const DomainLayoutContainer = connect(mapStateToProps, mapDispatchToProps)(
  Layout
)

export default DomainLayoutContainer



// WEBPACK FOOTER //
// src/layouts/Domain/DomainLayoutContainer.js